import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Output} from '@angular/core';
import {AddUser} from "@app/pages/admin/add-user/add-user";
import {AdminFormHelperService} from "@app/pages/admin/admin-form-helper.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {HttpClient} from "@angular/common/http";
import {AlertsService} from "@app/utilities/alerts.service";
import {EventEmitter} from "@angular/core";

@Component({
    selector: 'flex-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddUserComponent implements OnInit {
    cuid: string = '';
    @Output() userAdded = new EventEmitter();

    roles: Array<{ value: string, label: string }> = [
        {
            label: 'Super Admin',
            value: 'superAdmin'
        }, {
            label: 'Admin',
            value: 'admin'
        }, {
            label: 'General',
            value: 'general'
        }, {
            label: 'Limited',
            value: 'limited'
        }]


    constructor(public FormHelper: AdminFormHelperService, @Inject(MAT_DIALOG_DATA) CU, private http: HttpClient, public snackBar: AlertsService,
                private ref: ChangeDetectorRef) {
        this.cuid = CU.CU;
    }

    ngOnInit(): void {
        this.ref.detectChanges();
        this.FormHelper.addUserForm.reset();
    }

    onSubmit() {
        let Error: string;
        const addUser: AddUser = {
            cuid: this.cuid,
            username: this.FormHelper.addUserForm.value.username,
            fName: this.FormHelper.addUserForm.value.firstname,
            lName: this.FormHelper.addUserForm.value.lastname,
            email: this.FormHelper.addUserForm.value.emailAddress,
            phone: this.FormHelper.addUserForm.value.phonenumber,
            role: this.FormHelper.addUserForm.value.role,
            title: this.FormHelper.addUserForm.value.title,
            password: this.FormHelper.addUserForm.value.password
        };

        this.http.post('/api/secured/admin/addUser', addUser)
            .subscribe(res => {
                this.snackBar.getAlert('User Created', 'X')
                this.userAdded.emit("user added");
            },
            error => {
                Error = error.status + ' ' + error.statusText;
                this.snackBar.getError('Error: ' + Error, 'X')
            });
    }
}

